import GenerateAdaptationModal from "./GenerateAdaptationModal";

export default GenerateAdaptationModal;
